// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"03cc02f1","396":"366d0176","435":"27338dd3","902":"03a2cdda"}[chunkId] + ".chunk.js";
};